import React, { useState } from "react";
import ContactSaisie from "./ContactSaisie";
import ContactConfirmation from "./ContactConfirmation";
import emailjs from "@emailjs/browser";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; 
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

const ContactForm = () => {
  const [formData, setFormData] = useState(null);
  const [isConfirmed, setIsConfirmed] = useState(false);

  const handleFormSubmit = (data) => {
    setFormData(data);
  };

  const handleConfirmation = () => {
    setIsConfirmed(true);

    if (window.location.host === "localhost:3000") {
      toast.info("Local environment -> Email not sent. Simulating success!");
      return;
    }

    const templateParams = {
      to_name: "RS Transports",
      from_name: formData.user_name,
      from_email: formData.user_email,
      reply_to: formData.user_email,
      message: formData.message,
    };

    emailjs
      .send(
        "service_EmailJS_RS",
        "template_RS_contact",
        templateParams,
        { publicKey: '4P2bLvd0n1mjk5PBk' }
      )
      .then(
        (response) => {
            console.log("SUCCESS!", response.status, response.text);
            setIsConfirmed(true);
            toast("Your message has been sent successfully !");
          },
          (error) => {
            console.log('FAILED...', error);
            console.log("FAILED...", error.text);
            setIsConfirmed(false);
            alert("Error sending your message. Please try again !");
          }
      );
  };

  return (
    <div className="text-warning py-5 p-sm-1">
      {!formData ? (
        <ContactSaisie onSubmit={handleFormSubmit} />
      ) : !isConfirmed ? (
        <ContactConfirmation formData={formData} onConfirm={handleConfirmation} setFormData={setFormData} />
      ) : (
        <h2 className="text-center py-5 bg-dark text-white">
            <FontAwesomeIcon icon={faEnvelope} className="me-2" />
            Thank you for contacting us!
        </h2>
      )}
    <ToastContainer />
    </div>
  );
};

export default ContactForm;
